import {
  ArrowBigDown,
  ArrowBigLeft,
  ArrowBigRight,
  ArrowBigUp,
  Check,
  Expand,
  RotateCcw,
  TriangleAlert
} from "lucide-preact";
import "./Icon.css";

function withBaseClass(className = "") {
  return className ? `icon ${className}` : "icon";
}

export function IconCheck({ className = "" }) {
  return <Check class={withBaseClass(className)} />;
}

export function IconTriangleAlert({ className = "" }) {
  return <TriangleAlert class={withBaseClass(className)} />;
}

export function IconRotateCcw({ className = "" }) {
  return <RotateCcw class={withBaseClass(className)} />;
}

export function IconExpand({ className = "" }) {
  return <Expand class={withBaseClass(className)} />;
}

export function IconArrowKeyUp({ className = "" }) {
  return <ArrowBigUp class={withBaseClass(className)} />;
}

export function IconArrowKeyDown({ className = "" }) {
  return <ArrowBigDown class={withBaseClass(className)} />;
}

export function IconArrowKeyLeft({ className = "" }) {
  return <ArrowBigLeft class={withBaseClass(className)} />;
}

export function IconArrowKeyRight({ className = "" }) {
  return <ArrowBigRight class={withBaseClass(className)} />;
}
